import { http, HttpResponse } from 'msw';
import { ENDPOINTS } from '../constants/endpoints.constants';

const users = [
  {
    id: '1',
    firstName: 'super',
    lastName: 'admin',
    email: 'admin@domain.com',
    password: 'admin123',
    role: 'super_admin',
    is_active: true,
    permissions: [
      'user:read',
      'user:create',
      'user:update',
      'user:delete',
      'user:export',
      'user:reports_view',
      'user:reports_export',
      'dataset:read',
      'dataset:upload',
      'dataset:download',
      'document:read',
      'document:upload',
      'document:download',
      'document:download',
      'document:delete',
      'graph:read',
      'graph:upload',
      'graphs:read',
      'graphs:upload',
      'case-studies:read',
      'case-studies:create',
      'case-studies:update',
      'case-studies:delete',
    ],
  },
  {
    id: '2',
    firstName: 'John',
    lastName: 'Manager',
    email: 'john.manager@company.com',
    password: 'manager123',
    role: 'admin',
    is_active: true,
    permissions: ['user:read', 'dataset:read', 'document:read', 'document:upload', 'document:download', 'document:delete', 'graphs:read', 'graphs:upload', 'case-studies:read', 'case-studies:create', 'case-studies:update', 'case-studies:delete'],
  },
  {
    id: '3',
    firstName: 'Jane',
    lastName: 'User',
    email: 'jane.user@company.com',
    password: 'user123',
    role: 'NORMAL_USER',
    is_active: true,
    permissions: [] as string[],
  },
];

export const authHandler = [
  http.post(ENDPOINTS.LOGIN, async ({ request }) => {
    let body: { email?: string; password?: string; username?: string };
    try {
      body = (await request.json()) as { email?: string; password?: string; username?: string };
    } catch {
      return HttpResponse.json(
        {
          status: false,
          status_code: 400,
          message: 'Invalid request body format',
          data: null,
          error: 'Bad Request',
        },
        { status: 400 }
      );
    }

    const email = body?.email ?? body?.username;
    if (!email || !body?.password) {
      return HttpResponse.json(
        {
          status: false,
          status_code: 400,
          message: 'Email and password are required',
          data: null,
          error: 'Bad Request',
        },
        { status: 400 }
      );
    }

    await new Promise(resolve => setTimeout(resolve, 500));

    const user = users.find(u => u.email === email);

    if (!user || user.password !== body.password) {
      return HttpResponse.json(
        {
          status: false,
          status_code: 401,
          message: 'Invalid email or password',
          data: null,
          error: 'Unauthorized',
        },
        { status: 401 }
      );
    }

    const fullName = `${user.firstName} ${user.lastName}`.trim();

    return HttpResponse.json({
      status: true,
      status_code: 200,
      message: 'Success',
      data: {
        accessToken: 'mock_access_token_base64_part_1.mock_payload_with_role.mock_signature',
        refreshToken: 'mock_refresh_token_123',
        expiresIn: 1800,
        user: {
          id: user.id,
          Email: user.email,
          Name: fullName,
          Role: user.role === 'super_admin' ? 'SUPER_ADMIN' : 'NORMAL_ADMIN',
          permissions: user.permissions || [],
        },
      },
      error: null,
    });
  }),

  http.post(ENDPOINTS.REFRESH, async () => {
    return HttpResponse.json({
      status: true,
      status_code: 200,
      message: 'Success',
      data: {
        accessToken: 'new_mock_access_token_refreshed',
        refreshToken: 'mock_refresh_token_456',
        expiresIn: 1800,
      },
      error: null,
    });
  }),

  http.get(ENDPOINTS.ME, async () => {
    return HttpResponse.json({
      status: true,
      status_code: 200,
      message: 'OK',
      data: {
        user: {
          id: 'e26f84c2-aec3-41e8-8127-066209d282b8',
          Email: 'ajithkumar.sn@pitsolutions.com',
          Name: 'Ajith Ss',
          Role: 'NORMAL_ADMIN',
          is_active: true,
          permissions: ['case-studies:read', 'case-studies:create', 'case-studies:update', 'case-studies:delete', 'user:read', 'dataset:read', 'document:read', 'graphs:read', 'graphs:upload'],
        },
      },
      error: null,
    });
  }),
];
